import { render, staticRenderFns } from "./MajorAreaScore.vue?vue&type=template&id=7c5eae65&scoped=true"
import script from "./MajorAreaScore.vue?vue&type=script&lang=js"
export * from "./MajorAreaScore.vue?vue&type=script&lang=js"
import style0 from "./MajorAreaScore.vue?vue&type=style&index=0&id=7c5eae65&prod&lang=less"
import style1 from "./MajorAreaScore.vue?vue&type=style&index=1&id=7c5eae65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5eae65",
  null
  
)

export default component.exports